export default "__VITE_PUBLIC_ASSET__7cbde5b0__"